import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from './AuthContext';
import { CircularProgress, Box } from '@mui/material';

type AuthGuardProps = {
  children: ReactNode;
};

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { state } = useAuthContext();

  if (state.user === undefined || state.loading) {
    // 認証状態がまだ読み込まれていない場合、ローディング中とみなす
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!state.user) {
    // ユーザーが未認証の場合、ログインページにリダイレクト
    return <Navigate to="/login" />;
  }

  // ユーザーが認証されている場合、子コンポーネントを表示
  return <>{children}</>;
};

export default AuthGuard;
